import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '@/shared/contexts/UserContext';
import OnboardingWizard from './components/onboarding-wizard/OnboardingWizard';

const OnboardingPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (!user) {
      navigate('/sign-in');
    }
  }, [user, navigate]);

  const handleOnboardingComplete = (options?: { hasDealInsights?: boolean }) => {
    if (options?.hasDealInsights) {
      navigate('/intelligence-requests');
    } else {
      navigate('/my-reviews');
    }
  };

  if (!user) return null;

  return <OnboardingWizard fullScreen={true} onComplete={handleOnboardingComplete} />;
};

export default OnboardingPage;
